<!-- 🚀 CANDADO DE SEGURIDAD SAAS CORE: APAGA EL SSR EXCLUSIVAMENTE PARA ESTE DIÁLOGO -->
<div ngSkipHydration>

<div class="container-fluid mt-3 px-4" style="font-size: 0.88rem;">
  
  <!-- Encabezado de Navegación -->
  <div class="d-flex justify-content-between align-items-center mb-3 border-bottom pb-2">
    <div>
      <h2 class="h5 m-0 fw-bold text-dark">📋 Registrar Cuenta de Usuario JDE</h2>
      <span class="small text-muted font-monospace">F0002_USER / F980WSEC Provisioning Panel</span>
    </div>
  </div>

  <!-- Formulario Reactivo Central -->
  <form [formGroup]="userForm" (ngSubmit)="onSubmit()" class="card shadow-sm border-0 p-3 bg-white mx-auto" style="max-width: 700px; border-radius: 12px;">
    
    <div class="row g-2 mb-3">
      <!-- INPUT LOGIN ID -->
      <div class="col-md-6">
        <div class="form-floating">
          <input type="text" class="form-control font-monospace text-uppercase" id="userId" formControlName="userId" placeholder="amendoza"
                 [ngClass]="{'is-invalid': userForm.get('userId')?.touched && userForm.get('userId')?.invalid}">
          <label for="userId" class="text-primary fw-bold">Login User ID *</label>
          <div class="invalid-feedback">El ID de usuario es obligatorio, alfanumérico y sin espacios.</div>
        </div>
      </div>

      <!-- SELECTOR REACONDICIONADO DE IDENTIDAD DESDE F0101 (STAFF INTERNO FILTRADO) -->
      <div class="col-md-6">
        <div class="form-floating">
          <select class="form-select text-uppercase fw-semibold" id="an8" formControlName="an8"
                  [ngClass]="{'is-invalid': an8Control?.touched && an8Control?.invalid}">
            <option value="">-- Seleccione Personal Interno --</option>
            <option *ngFor="let emp of empleadosF0101" [value]="emp.an8">
              {{ emp.alph }} (AN8: {{ emp.an8 }}) — [{{ emp.type }}]
            </option>
          </select>
          <label for="an8" class="text-primary fw-bold">Vínculo al Address Book *</label>
          <div class="invalid-feedback">Debe asociar obligatoriamente una identidad interna de la f0101 (Clientes excluidos).</div>
        </div>
      </div>
    </div>

    <div class="row g-2 mb-3">
      <!-- INPUT CONTRASEÑA OBLIGATORIA -->
      <div class="col-md-6">
        <div class="form-floating">
          <input type="password" class="form-control" id="password" formControlName="password" placeholder="Clave"
                 [ngClass]="{'is-invalid': userForm.get('password')?.touched && userForm.get('password')?.invalid}">
          <label for="password">Contraseña de Seguridad Inicial *</label>
          <div class="invalid-feedback">La clave es requerida y debe contener al menos 6 caracteres.</div>
        </div>
      </div>

      <!-- SWITCH CONTROL DE ACCESO ACTIVO -->
      <div class="col-md-6 d-flex align-items-center ps-3">
        <div class="form-check form-switch m-0">
          <input class="form-check-input" type="checkbox" id="enabledSwitch" formControlName="enabled">
          <label class="form-check-label fw-bold text-secondary" for="enabledSwitch">Habilitar cuenta inmediatamente</label>
        </div>
      </div>
    </div>

    <!-- 🛡️ MATRIZ DE ASIGNACIÓN DE PRIVILEGIOS POR UDC (Se mantiene intacta y funcional para multi-rol) -->
    <div class="card bg-light border-0 p-3 mb-4">
      <label class="fw-bold text-dark border-bottom pb-1 mb-2 small text-uppercase" style="letter-spacing: 0.5px;">
        🛡️ Matriz de Privilegios Autorizados (Catálogo UDC)
      </label>
      
      <div formArrayName="rolesSeleccionados" class="row">
        <div *ngFor="let ctrl of rolesControls; let i = index" class="col-md-6 form-check mb-2 ps-4">
          <input class="form-check-input" type="checkbox" [formControlName]="i" [id]="'rol_add_' + i">
          <label class="form-check-label fw-semibold text-dark ps-1" [for]="'rol_add_' + i" style="font-size: 0.85rem; cursor: pointer;">
            💼 {{ catRolesUdc[i]?.description }} 
            <span class="badge bg-dark font-monospace text-xs ms-1">{{ catRolesUdc[i]?.strValue1 }}</span>
          </label>
        </div>
      </div>
    </div>

    <!-- 🎛️ BOTONERA DE ENVÍO -->
    <div class="p-2 bg-white" style="border-radius: 8px;">
        <div class="d-flex justify-content-end align-items-center gap-2 mt-2 border-top pt-3">
          <button type="button" class="btn btn-sm btn-outline-secondary px-4 fw-bold" (click)="onCancelar()">
            ❌ Cancelar
          </button>
          <button type="submit" class="btn btn-sm btn-success text-white px-4 fw-bold shadow-sm">
            🚀 Guardar e Integrar Usuario
          </button>
        </div>
    </div>

  </form>
</div>
</div>